export default __webpack_public_path__ + "static/media/logo-grupo-monaco.e438ef4e.jpg";